import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';
import { firebaseConfig } from './firebase-config';

// Questo file è una best practice . importare tutte le funzioni da utilizzare per firebase qua

const firebaseApp = initializeApp(firebaseConfig);
export const messaging = getMessaging(firebaseApp);
// ! se si decide di non usare eliminarlo completamente per non tracciare senza consenso
export const analytics = getAnalytics(firebaseApp);
// let analyticsEnabled = false;

// try {
//     setAnalyticsCollectionEnabled(analytics, false);
// } catch {
//     // avoid blocking app startup if analytics collection setup fails
// }

// export const initAnalyticsIfAllowed = (
//     permessiAzioni: string[],
//     userUuid?: string | null,
// ) => {
//     // ! se decommentato CAMBIARE CON IL PERMESSO CORRETTO e non CAN_USE_CLARITY
//     // if (analyticsEnabled || !permessiAzioni.includes('CAN_USE_CLARITY')) {
//     if (analyticsEnabled ) {
//         return;
//     }

//     try {
//         setAnalyticsCollectionEnabled(analytics, true);
//         logEvent(analytics, 'analytics_init_test', {
//             debug_mode: true,
//             source: 'whoami_init',
//         });
//         if (userUuid !== undefined && userUuid !== null) {
//             setUserId(analytics, String(userUuid));
//         }
//         analyticsEnabled = true;
//     } catch {
//         // avoid blocking auth flow if analytics fails
//     }
// };
